import { render, staticRenderFns } from "./AppPopoverButton.vue?vue&type=template&id=b2a6e8f4"
import script from "./AppPopoverButton.vue?vue&type=script&lang=js"
export * from "./AppPopoverButton.vue?vue&type=script&lang=js"
import style0 from "./AppPopoverButton.vue?vue&type=style&index=0&id=b2a6e8f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports